import React, { useState, useEffect } from "react";
import { getProjectFromStorage } from "../../cockpit/fetch";
import { useParams } from "react-router-dom";
import PageComponents from "../../components/cockpit/PageComponents";
import * as Config from '../../config';
import './Project.scss';
import Page404 from "../Page/404";
import { useTransactions } from "../../hooks/useTransactions";

const Project = () => {
    const [page, setPage] = useState(null);
    const [transactionSummary, setTransactionSummary] = useState<{ transactions: number; total: number } | null>(null);
    const transactions = useTransactions();

    const { slug } = useParams();

    useEffect(() => {
        let isCancelled = false;
        getProjectFromStorage(slug, (data) => {
            if (!isCancelled) {
                setPage(data);
            }
        })
        return () => {
            isCancelled = true;
        }
    }, [slug])

    useEffect(() => {
        let isCancelled = false;

        if (!page?.project_id) {
            return;
        }

        transactions.getTransactionsPerProject(page.project_id).then(res => {
            if (!isCancelled) {
                const { transactions: amount = 0, total = 0 } = res.data;
                setTransactionSummary({ transactions: Number(amount), total: Number(total) });
            }
        }).catch(err => {
            if (!isCancelled) {
                console.error(err);
            }
        })
        return () => {
            isCancelled = true;
        }
    }, [page])

    const currentBalance = transactionSummary ? Number(page?.current_balance || 0) + transactionSummary.total : null;
    const myInvestment = transactionSummary ? transactionSummary.transactions : null;

    return <>
        {page && <>
            {page === 'error' ? <Page404 /> :
                <div className={`sec-pad thm-container Project project-${page.title.toLowerCase()}`}>
                    <h1>{page.title}</h1>
                    <div className="project-meta">
                        <p className="project-id">{page.project_id}</p>
                        <p className="project-deadline">Deadline: {new Date(page.deadline).toLocaleDateString()}</p>
                    </div>

                    <div className="project-stats">
                        <div className="stat-box">
                            <span className="stat-label">Target</span>
                            <span className="stat-value">${parseInt(page.target).toLocaleString()}</span>
                        </div>
                        <div className="stat-box">
                            <span className="stat-label">Current Balance</span>
                            <span className="stat-value">{currentBalance !== null ? `$${currentBalance.toLocaleString()}` : 'Loading...'}</span>
                        </div>
                        <div className="stat-box">
                            <span className="stat-label">ROI</span>
                            <span className="stat-value">{page.roi}%</span>
                        </div>
                        <div className="stat-box">
                            <span className="stat-label">My Investment</span>
                            <span className="stat-value">{myInvestment !== null ? `$${myInvestment.toLocaleString()}` : 'Loading...'}</span>
                        </div>
                    </div>

                    <div className="project-progress">
                        <div className="progress-bar">
                            <div className="progress-fill" style={{width: `${currentBalance !== null ? (currentBalance / Number(page.target || 1)) * 100 : 0}%`}}></div>
                        </div>
                        <p className="progress-text">{currentBalance !== null ? `${Math.round((currentBalance / Number(page.target || 1)) * 100)}% Funded` : 'Calculating funding...'}</p>
                    </div>

                    {page.gallery && page.gallery.length > 0 && (
                        <div className="project-gallery">
                            {page.gallery.map((image: { path: string; meta: { title?: string } }, index: number) => (
                                <img key={index} src={Config.COCKPIT_HOST + image.path} alt={image.meta.title || `Gallery ${index + 1}`} />
                            ))}
                        </div>
                    )}

                    <div className="project-description">
                        <p>{page.content}</p>
                    </div>
                </div>
            }</>
        }
    </>
}
export default Project;